import {BaseWrapper} from '../../../../allkey/framework/parameters/BaseWrapper';
import {ProcessCriteriaExt} from './ProcessCriteriaExt';
import {ProcessExt} from '../message/ProcessExt';
import {ProcessScenarioExt} from './ProcessScenarioExt';

export class ProcessExtWrapper extends BaseWrapper<ProcessExt, ProcessCriteriaExt, ProcessScenarioExt>  {}

